import {Billing} from '../features/invoices'
import routeConfig from './constants'

export default [
  {
    path: '/',
    redirectTo: '/invoices',
  },
  {
    path: '/invoices',
    component: Billing,
  },
  {
    path: routeConfig.BUYER_FINANCING.URL,
    component: Billing,
    componentProps: {
      activeTab: routeConfig.BUYER_FINANCING.key,
    },
  },
  {
    path: routeConfig.SELLER_FINANCING.URL,
    component: Billing,
    componentProps: {
      activeTab: routeConfig.SELLER_FINANCING.key,
    },
  },
]
